const truncateText = (text, maxLength = 0) => {
  if (text.length > maxLength) {
    return `${text.slice(0, maxLength).trim()}...`;
  } else {
    return text;
  }
};

export default truncateText;
